export default "__VITE_ASSET__BS484tsC__"